import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { LazyImageDirective } from '../../../../../../directive/lazyImage.directive';
import { NgClass } from '@angular/common';
import { PictureComponent } from '../../../../../../shared/components/picture/picture.component';
import { AppearDirective } from '../../../../../../directive/appear.directive';

@Component({
    selector: 'app-step-five',
    templateUrl: './step5.component.html',
    styleUrls: ['./step5.component.scss'],
    standalone: true,
    imports: [AppearDirective, PictureComponent, NgClass, LazyImageDirective, TranslateModule]
})
export class Step5Component {
  animStart = false;

  onAppear() {
    this.animStart = true;
  }
}
